import {getCurrentUser} from 'lib/utils'

export const withoutTZOffset = iso8601DateStr => (iso8601DateStr || '').replace(/[-+][0-9]{2}:[0-9]{2}$/, '')

export const readDateFormatFromPreferences = () => {
  switch (getCurrentUser().preferences.date_format) {
    case 'dmy':
      return 'D/M/YYYY'
    case 'ymd':
      return 'YYYY/M/D'
    default: // mdy
      return 'M/D/YYYY'
  }
}

export const readFirstDayOfWeekFromPreferences = () => {
  return getCurrentUser().weekStartsOn || 0
}
